// FR translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const fr = {
  "app.title": "Surplify",
  "nav.home": "Accueil",
  "nav.search": "Rechercher",
  "nav.watchlist": "Liste de suivi",
  "nav.requests": "Mes demandes",
  "nav.dashboard": "Tableau de bord",
  "nav.admin": "Admin",
  "nav.import": "Importer",
  "nav.login": "Connexion",
  "nav.register": "S'inscrire",
  "nav.logout": "Déconnexion",
  "nav.groupRequests": "Demandes du site",
  "groupRequests.title": "Demandes entrantes du site",
  "groupRequests.subtitle": "Demandes adressées aux sites de votre groupe",
  "groupRequests.pending": "en attente",
  "groupRequests.filterAll": "Tous les statuts",
  "groupRequests.empty": "Aucune demande entrante",
  "groupRequests.emptyHint": "Il n'y a actuellement aucune demande adressée à vos sites.",
  "groupRequests.site": "Site cible",
  "material.request": "Demander un matériau",
  "material.addToWatchlist": "Ajouter au suivi",
  "material.removeFromWatchlist": "Retirer du suivi",
  "status.available": "Disponible",
  "status.reserved": "Réservé",
  "status.pending": "En attente",
  "status.approved": "Approuvé",
  "status.rejected": "Rejeté",
  "status.completed": "Terminé",
  "status.documentation_missing": "Docs manquants",
  "badge.groupOnly": "Groupe uniquement",
  "badge.external": "Externe",
  "badge.slowMoving": "Rotation lente",
  "badge.nonMoving": "Sans rotation",
  "badge.missingDocs": "Docs manquants",
  "filter.category": "Catégorie",
  "filter.site": "Site",
  "filter.age": "Ancienneté",
  "filter.manufacturer": "Fabricant",
  "filter.price": "Prix",
  "filter.width": "Largeur",
  "filter.country": "Pays",
  "filter.allCountries": "Tous les pays",
  "common.search": "Rechercher des matériaux...",
  "common.loading": "Chargement...",
  "common.noResults": "Aucun résultat",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.submit": "Soumettre",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.view": "Voir",
  "common.close": "Fermer",
  "common.back": "Retour",
  "common.saving": "Enregistrement...",
  "common.create": "Créer",
  "home.newListings": "Nouveaux articles",
  "home.highValue": "Stock de haute valeur",
  "home.featured": "Matériaux en vedette",
  "auth.email": "E-mail",
  "auth.password": "Mot de passe",
  "auth.name": "Nom complet",
  "auth.loginTitle": "Connexion",
  "auth.registerTitle": "Créer un compte",
  "auth.noAccount": "Pas de compte?",
  "auth.hasAccount": "Déjà un compte?",
  "auth.registrationSuccess": "Inscription réussie!",
  "auth.pendingApproval": "Votre compte a été créé et est en attente d'approbation par l'administrateur.",
  "auth.registerDesc": "Créez un compte pour commencer à échanger des matériaux",
  "dashboard.totalInventory": "Inventaire total",
  "dashboard.slowMoving": "Rotation lente (>180 jours)",
  "dashboard.nonMoving": "Sans rotation (>360 jours)",
  "dashboard.pendingRequests": "Demandes en attente",
  "dashboard.monthlyTransfers": "Transferts mensuels",
  "dashboard.overdueItems": "Articles en retard",
  "dashboard.subtitle": "Aperçu global de l'inventaire",
  "dashboard.siteFilter": "Filtrer par site",
  "dashboard.allSites": "Tous les sites",
  "dashboard.slowMovingDesc": "Matériaux de 181-360 jours",
  "dashboard.nonMovingDesc": "Matériaux de plus de 360 jours",
  "dashboard.transfersDesc": "Transferts internes ce mois",
  "dashboard.overdueDesc": "Articles nécessitant attention",
  "dashboard.ageChart": "Inventaire par ancienneté",
  "dashboard.ageChartDesc": "Répartition de la valeur par ancienneté",
  "dashboard.siteRanking": "Classement des sites",
  "dashboard.siteRankingDesc": "Sites avec le plus d'inventaire à rotation lente",
  "dashboard.overdueTitle": "Articles en retard (>360 jours)",
  "dashboard.overdueDesc2": "Ces articles nécessitent une attention immédiate",
  "dashboard.viewAllOverdue": "Voir tous les {{count}} articles en retard",
  "dashboard.viewNonMoving": "Voir le stock sans rotation",
  "dashboard.pendingRequestsLink": "Demandes en attente",
  "dashboard.importMaterials": "Importer des matériaux",
  "dashboard.age0_90": "0-90 jours",
  "dashboard.age91_180": "91-180 jours",
  "dashboard.age181_360": "181-360 jours",
  "dashboard.ageGt360": ">360 jours",
  "dashboard.slowMovingItems": "Articles à rotation lente",
  "dashboard.totalMaterials": "Total matériaux",
  "dashboard.totalMaterialsDesc": "Matériaux actifs en inventaire",
  "dashboard.externalSales": "Ventes externes",
  "dashboard.externalSalesDesc": "Ventes externes ce mois",
  "dashboard.sitePending": "Demandes en attente",
  "dashboard.sitePendingDesc": "Demandes en attente pour ce site",
  "import.title": "Importer des matériaux",
  "import.subtitle": "Importer et exporter des données matériaux via Excel",
  "import.downloadTemplate": "Télécharger le modèle",
  "import.uploadFile": "Télécharger un fichier",
  "import.validate": "Valider",
  "import.execute": "Exécuter l'importation",
  "import.mode.overwrite": "Tout écraser",
  "import.mode.enrich": "Enrichir uniquement",
  "import.mode.selective": "Sélectionner les champs",
  "import.export": "Exporter",
  "import.exportTitle": "Exporter les matériaux",
  "import.exportDesc": "Télécharger les données matériaux en fichier Excel avec filtres",
  "import.exportDownload": "Télécharger Excel",
  "request.title": "Demander un matériau",
  "request.quantity": "Quantité",
  "request.message": "Message (optionnel)",
  "request.type.internal": "Transfert interne",
  "request.type.external": "Demande externe",
  "requests.tab.my": "Mes demandes",
  "requests.tab.incoming": "Demandes entrantes",
  "requests.details": "Détails de la demande",
  "requests.detail.article": "Article",
  "requests.detail.quantity": "Quantité demandée",
  "requests.detail.type": "Type",
  "requests.detail.requestedBy": "Demandé par",
  "requests.detail.date": "Date",
  "requests.detail.message": "Message",
  "requests.from": "De",
  "requests.viewDetails": "Voir les détails",
  "requests.loginRequired": "Connexion requise",
  "requests.loginHint": "Veuillez vous connecter pour voir vos demandes",
  "requests.empty.my": "Aucune demande envoyée",
  "requests.empty.myHint": "Vous n'avez pas encore fait de demande. Parcourez les matériaux!",
  "requests.empty.incoming": "Aucune demande entrante",
  "requests.empty.incomingHint": "Vous n'avez pas de demandes entrantes pour vos matériaux.",
  "requests.action.approve": "Approuver",
  "requests.action.reject": "Rejeter",
  "requests.action.complete": "Terminer",
  "requests.action.approveTitle": "Approuver la demande",
  "requests.action.rejectTitle": "Rejeter la demande",
  "requests.action.completeTitle": "Terminer la demande",
  "requests.action.approveDesc": "Cela approuvera la demande et réservera le matériau.",
  "requests.action.rejectDesc": "Cela rejettera la demande.",
  "requests.action.completeDesc": "Cela terminera le transfert et mettra à jour l'inventaire.",
  "requests.action.approvedSuccess": "Demande approuvée",
  "requests.action.rejectedSuccess": "Demande rejetée",
  "requests.action.completedSuccess": "Demande terminée - inventaire mis à jour",
  "requests.action.failed": "Échec de la mise à jour de la demande",
  "restricted.title": "Contenu restreint",
  "restricted.loginHint": "Connectez-vous pour voir les prix, quantités et emplacements.",
  "restricted.approvalHint": "Votre compte est en attente d'approbation.",
  "restricted.cardHint": "Connectez-vous et obtenez l'approbation pour voir les détails",
  "admin.users": "Utilisateurs",
  "admin.usersDesc": "Gérer les inscriptions et approbations des utilisateurs",
  "admin.noUsers": "Aucun utilisateur trouvé",
  "admin.approved": "Approuvé",
  "admin.pending": "En attente",
  "admin.registeredAt": "Inscrit",
  "admin.approveUser": "Approuver",
  "admin.revokeUser": "Révoquer",
  "admin.userApproved": "Utilisateur approuvé avec succès",
  "admin.userRevoked": "Accès utilisateur révoqué",
  "admin.userApproveFailed": "Échec de la mise à jour du statut",
  "admin.deleteUser": "Supprimer l'utilisateur",
  "admin.deleteUserTitle": "Supprimer l'utilisateur",
  "admin.deleteUserConfirm": "Êtes-vous sûr de vouloir supprimer définitivement l'utilisateur {{name}} ({{email}}) ? Cette action est irréversible.",
  "admin.userDeleted": "Utilisateur supprimé avec succès",
  "admin.userDeleteFailed": "Échec de la suppression de l'utilisateur",
  "admin.categoryTree": "Arbre des catégories",
  "admin.categoryTreeDesc": "Gérer les catégories de produits et leur hiérarchie",
  "admin.addCategory": "Ajouter une catégorie",
  "admin.editCategory": "Modifier la catégorie",
  "admin.deleteCategory": "Supprimer la catégorie",
  "admin.addCategoryDesc": "Créer une nouvelle catégorie de produit",
  "admin.editCategoryDesc": "Modifier le nom, la catégorie parent ou l'ordre",
  "admin.deleteCategoryConfirm": "Êtes-vous sûr de vouloir supprimer \"{{name}}\"?",
  "admin.categoryName": "Nom de catégorie",
  "admin.categoryNamePlaceholder": "ex. Films et feuilles",
  "admin.parentCategory": "Catégorie parent",
  "admin.noParent": "Aucune (niveau racine)",
  "admin.sortOrder": "Ordre de tri",
  "admin.categoryCreated": "Catégorie créée",
  "admin.categoryUpdated": "Catégorie mise à jour",
  "admin.categoryDeleted": "Catégorie désactivée",
  "admin.categoryCreateFailed": "Échec de la création de la catégorie",
  "admin.categoryUpdateFailed": "Échec de la mise à jour de la catégorie",
  "admin.categoryDeleteFailed": "Échec de la suppression de la catégorie",
  "admin.noCategoriesFound": "Aucune catégorie trouvée.",
  "admin.delete": "Supprimer",
  "create.newTitle": "Publier un matériau",
  "create.editTitle": "Modifier le matériau",
  "create.materialInfo": "Informations sur le matériau",
  "create.title": "Titre",
  "create.titlePlaceholder": "ex. Film PE 500mm transparent",
  "create.description": "Description",
  "create.descPlaceholder": "Description détaillée du matériau...",
  "create.selectCategory": "Sélectionner une catégorie",
  "create.companyGroup": "Groupe d'entreprises",
  "create.selectGroup": "Sélectionner un groupe",
  "create.partNumber": "Numéro de pièce",
  "create.thickness": "Épaisseur",
  "create.grade": "Qualité du matériau",
  "create.coreDiameter": "Diamètre du noyau",
  "create.skuInfo": "Données de stock (SKU)",
  "create.addSku": "Ajouter du stock",
  "create.addMore": "Ajouter SKU",
  "create.selectSite": "Sélectionner un site",
  "create.articleNumber": "Numéro d'article",
  "create.rolls": "Nombre de rouleaux",
  "create.bookValue": "Valeur comptable",
  "create.listPrice": "Prix catalogue",
  "create.productionDate": "Date de production",
  "create.customerSpecific": "Spécifique au client",
  "create.compliant": "Conforme",
  "create.notesInternal": "Notes internes",
  "create.notesInternalPlaceholder": "Visible uniquement en interne...",
  "create.publish": "Publier",
  "create.materialCreated": "Matériau créé avec succès",
  "create.materialUpdated": "Matériau mis à jour avec succès",
  "create.existingSkus": "Stock existant",
  "create.noNewSkus": "Aucun nouveau stock ajouté",
  "create.previewHint": "Aperçu du matériau",
  "create.untitled": "Matériau sans titre",
  "create.titleRequired": "Le titre est obligatoire",
  "create.categoryRequired": "La catégorie est obligatoire",
  "create.manufacturerRequired": "Le fabricant est obligatoire",
  "create.partNumberRequired": "Le numéro de pièce est obligatoire",
  "create.groupRequired": "Le groupe d'entreprises est obligatoire",
  "create.siteRequired": "Le site est obligatoire",
  "create.articleRequired": "Le numéro d'article est obligatoire",
  "create.quantityRequired": "La quantité est obligatoire",
  "create.saveError": "Erreur lors de l'enregistrement",
  "watchlist.loginRequired": "Connexion requise",
  "watchlist.loginHint": "Connectez-vous pour voir votre liste de suivi",
  "watchlist.empty": "Votre liste de suivi est vide",
  "watchlist.emptyHint": "Parcourez les matériaux et cliquez sur l'icône cœur",
  "watchlist.browse": "Parcourir les matériaux",
  "watchlist.remove": "Retirer",
  "watchlist.priceOnRequest": "Prix sur demande",
  "watchlist.addedOn": "Ajouté le",
  "watchlist.itemCount": "{{count}} articles dans votre liste",
  "sustainability.title": "Impact sur la durabilité",
  "sustainability.subtitle": "Réduction des déchets par redistribution intelligente",
  "sustainability.heroTagline": "Économie circulaire pour l'emballage",
  "sustainability.heroDesc": "Chaque matériau redistribué est un de moins produit à partir de zéro. Ensemble, nous réduisons le CO2, économisons les ressources et construisons un écosystème de fabrication circulaire.",
  "sustainability.co2Saved": "CO2 économisé",
  "sustainability.co2SavedDesc": "Émissions évitées estimées",
  "sustainability.materialsRedistributed": "Matériaux redistribués",
  "sustainability.materialsRedistributedDesc": "Transférés avec succès entre sites",
  "sustainability.valueSaved": "Valeur préservée",
  "sustainability.valueSavedDesc": "Fonds de roulement préservé",
  "sustainability.activeSites": "Sites actifs",
  "sustainability.activeSitesDesc": "Sites participant à la redistribution",
  "sustainability.circularRate": "Taux d'économie circulaire",
  "sustainability.circularRateDesc": "Matériaux avec une seconde vie",
  "sustainability.atRisk": "Matériaux à risque",
  "sustainability.atRiskDesc": "Stock à rotation lente/nulle redistribuable",
  "sustainability.pendingRedist": "Redistributions en cours",
  "sustainability.pendingRedistDesc": "Transferts en cours de traitement",
  "sustainability.availableForReuse": "Disponible pour réutilisation",
  "sustainability.impactBanner": "Ensemble, nous prévenons les déchets d'emballage et économisons les ressources",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Télécharger le rapport ESG",
  "sustainability.downloadReportDesc": "Générer un rapport PDF de durabilité",
  "sustainability.reportGenerating": "Génération du rapport...",
  "sustainability.reportReady": "Rapport ESG téléchargé avec succès",
  "sustainability.reportError": "Erreur lors de la génération du rapport",
  "footer.tagline": "Place de marché gouvernée pour les matériaux d'emballage excédentaires.",
  "footer.marketplace": "Place de marché",
  "footer.forPartners": "Pour les partenaires",
  "footer.support": "Support",
  "footer.legalTitle": "Mentions légales",
  "footer.agb": "CGV",
  "footer.impressum": "Mentions légales",
  "footer.datenschutz": "Politique de confidentialité",
  "footer.datenschutzeinstellungen": "Paramètres de confidentialité",
  "footer.rights": "Tous droits réservés.",
  "nav.standardMaterials": "Matériaux standard",
  "nav.transactions": "Transactions",
  "nav.matching": "Material Matching",
  "nav.analytics": "Analytique",
  "nav.language": "Langue",
  "nav.switchGroup": "Changer de groupe",
  "matching.title": "Material Matching",
  "matching.subtitle": "Correspondance automatique des excédents avec la demande d'autres sites",
  "matching.refresh": "Actualiser",
  "matching.matches": "Correspondances",
  "matching.matchRate": "Taux de correspondance",
  "matching.potSavings": "Écon. pot.",
  "matching.sites": "Sites",
  "matching.surplusAvailable": "{{count}} excédents disponibles",
  "matching.demandPositions": "{{count}} positions de demande",
  "matching.matchedQuantity": "{{count}} kg quantité correspondante",
  "matching.providers": "{{count}} fournisseurs",
  "matching.consumers": "{{count}} demandeurs",
  "matching.topMaterials": "Matériaux les plus correspondants",
  "matching.offerSite": "Site fournisseur",
  "matching.demandSite": "Site demandeur",
  "matching.manufacturer": "Fabricant",
  "matching.searchManufacturer": "Rechercher fabricant...",
  "matching.allSites": "Tous les sites",
  "matching.noMatches": "Aucune correspondance",
  "matching.noMatchesDesc": "Aucune correspondance entre les excédents et les listes de demande.",
  "matching.matchesFound": "{{count}} correspondance(s) trouvée(s)",
  "matching.material": "Matériau",
  "matching.provider": "Fournisseur",
  "matching.consumer": "Demandeur",
  "matching.quantity": "Quantité",
  "matching.bookValue": "Valeur comptable",
  "matching.age": "Ancienneté",
  "matching.width": "Largeur",
  "matching.widthFit": "Conforme",
  "matching.widthDeviation": "Écart",
  "matching.action": "Action",
  "matching.view": "Voir",
  "matching.age0_90": "0–90 jours",
  "matching.age91_180": "91–180 jours",
  "matching.age181_360": "181–360 jours",
  "matching.ageGt360": "> 360 jours",
  "analytics.title": "Analytique et rapports",
  "analytics.subtitle": "Analyse des tendances, performance des sites et évaluations des correspondances",
  "analytics.tabTrends": "Tendances",
  "analytics.tabSites": "Sites",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "6 derniers mois",
  "analytics.last12Months": "12 derniers mois",
  "analytics.last24Months": "24 derniers mois",
  "analytics.inventoryTrend": "Évolution des stocks",
  "analytics.inventoryTrendDesc": "Développement mensuel du nombre d'articles et de la valeur des stocks",
  "analytics.articles": "Articles",
  "analytics.valueKEUR": "Valeur (kEUR)",
  "analytics.transactionVolume": "Volume de transactions",
  "analytics.transactionVolumeDesc": "Transactions mensuelles",
  "analytics.transactions": "Transactions",
  "analytics.requestTrend": "Évolution des demandes",
  "analytics.requestTrendDesc": "Total vs. demandes complétées",
  "analytics.requests": "Demandes",
  "analytics.completed": "Terminées",
  "analytics.siteComparison": "Comparaison des sites : valeur des stocks",
  "analytics.siteComparisonDesc": "Valeur totale (kEUR) par site",
  "analytics.redistributionRanking": "Classement de redistribution",
  "analytics.redistributionRankingDesc": "Redistributions terminées par site",
  "analytics.redistributions": "Redistributions",
  "analytics.openRequests": "Demandes ouvertes",
  "analytics.siteDetails": "Détails du site",
  "analytics.site": "Site",
  "analytics.value": "Valeur (kEUR)",
  "analytics.slowMoving": "Rotation lente",
  "analytics.redistributed": "Redistribué",
  "analytics.demand": "Demande",
  "analytics.noSiteData": "Aucune donnée de site disponible",
  "analytics.kpiMatches": "Correspondances",
  "analytics.kpiMatchRate": "Taux de correspondance",
  "analytics.kpiMatchedValue": "Valeur correspondante",
  "analytics.kpiMaterials": "Matériaux",
  "analytics.topMatchedMaterials": "Matériaux les plus correspondants",
  "analytics.categoryDistribution": "Correspondances par catégorie",
  "analytics.sitePairFlows": "Flux de sites (Fournisseur → Demandeur)",
  "analytics.sitePairFlowsDesc": "Flux de matériaux les plus fréquents entre sites",
  "analytics.noData": "Pas de données",
  "analytics.noMatchingData": "Aucune donnée de correspondance disponible",
  "transactions.title": "Transactions",
  "transactions.subtitle": "Toutes les transactions terminées et en cours",
  "transactions.allStatuses": "Tous les statuts",
  "transactions.statusCompleted": "Terminée",
  "transactions.statusCancelled": "Annulée",
  "transactions.statusPending": "Ouverte",
  "transactions.total": "Transactions",
  "transactions.completed": "Terminées",
  "transactions.totalValue": "Valeur totale",
  "transactions.date": "Date",
  "transactions.material": "Matériau",
  "transactions.type": "Type",
  "transactions.seller": "Vendeur",
  "transactions.buyer": "Acheteur",
  "transactions.quantity": "Quantité",
  "transactions.value": "Valeur",
  "transactions.fee": "Frais",
  "transactions.status": "Statut",
  "transactions.rating": "Évaluation",
  "transactions.internal": "Interne",
  "transactions.external": "Externe",
  "transactions.empty": "Pas encore de transactions",
  "transactions.emptyDesc": "Les transactions sont créées automatiquement lors de la finalisation des demandes.",
  "transactions.rate": "Évaluer",
  "transactions.rated": "Évalué",
  "transactions.rateTitle": "Évaluer la transaction",
  "transactions.counterparty": "Contrepartie",
  "transactions.unknown": "Inconnu",
  "transactions.commentLabel": "Commentaire (optionnel)",
  "transactions.commentPlaceholder": "Comment était la coopération ?",
  "transactions.submitRating": "Soumettre l'évaluation",
  "transactions.submitting": "Envoi en cours...",
  "transactions.ratingSuccess": "Évaluation soumise",
  "transactions.ratingError": "Erreur lors de l'évaluation",
  "transactions.ratingRequired": "Veuillez évaluer au moins une catégorie",
  "transactions.loadError": "Erreur lors du chargement des transactions",
  "transactions.reviews": "Évaluations",
  "transactions.noReviews": "Pas encore d'évaluations.",
  "transactions.comments": "Commentaires",
  "transactions.group": "Groupe",
  "transactions.review": "évaluations",
  "notifications.title": "Notifications",
  "notifications.allRead": "Toutes lues",
  "notifications.none": "Pas de notifications",
  "notifications.noFiltered": "Pas de notifications correspondantes",
  "notifications.filterAll": "Toutes",
  "notifications.filterMatches": "Correspondances",
  "notifications.filterOther": "Autres",
  "notifications.newMatch": "{{count}} nouvelle correspondance de matériau",
  "notifications.newMatches": "{{count}} nouvelles correspondances de matériaux",
  "notifications.goToDashboard": "Aller au tableau de bord",
  "notifications.matchDashboard": "Afficher le tableau de bord Material Matching",
  "notifications.justNow": "à l'instant",
  "notifications.minutesAgo": "il y a {{count}} min",
  "notifications.hoursAgo": "il y a {{count}} h",
  "notifications.daysAgo": "il y a {{count}} j",
  "notifications.site": "Site",
  "notifications.typeMatch": "Correspondance",
  "notifications.typeApproval": "Correspondance d'approbation",
  "notifications.typeRequest": "Demande",
  "notifications.typeEscalation": "Escalade",
  "notifications.typeLogistics": "Logistique",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Acheter. Vendre. Réutiliser. Les surplus — plus intelligemment.",
  "partners.heroSubtitle": "Rejoignez la place de marché leader des surplus d'emballages. Accédez à des matériaux vérifiés des meilleurs fabricants et économisez jusqu'à 40% sur vos coûts d'achat.",
  "partners.ctaRegister": "S'inscrire comme partenaire",
  "partners.ctaBrowse": "Parcourir les matériaux",
  "partners.trust1": "Inscription gratuite",
  "partners.trust2": "Fournisseurs vérifiés",
  "partners.trust3": "Sans engagement",
  "partners.howItWorksLabel": "Processus",
  "partners.howItWorksTitle": "Comment ça marche",
  "partners.howItWorksSubtitle": "Trois étapes simples pour commencer à économiser.",
  "partners.step1Title": "S'inscrire",
  "partners.step1Desc": "Créez votre compte entreprise en quelques minutes. Notre équipe vérifiera votre société et activera votre accès.",
  "partners.step2Title": "Parcourir",
  "partners.step2Desc": "Recherchez des milliers de matériaux surplus vérifiés de fabricants d'emballages.",
  "partners.step3Title": "Demander",
  "partners.step3Desc": "Envoyez une demande directement au fournisseur. La plateforme gère l'ensemble du processus.",
  "partners.benefitsTitle": "Pourquoi choisir Surplify",
  "partners.benefit1Title": "Économisez jusqu'à 40%",
  "partners.benefit1Desc": "Accédez aux matériaux surplus à une fraction du coût d'origine.",
  "partners.benefit2Title": "Qualité vérifiée",
  "partners.benefit2Desc": "Chaque annonce inclut les données du fabricant et des rapports d'état.",
  "partners.benefit3Title": "Impact ESG",
  "partners.benefit3Desc": "Chaque achat réduit les émissions de CO2. Traçabilité complète pour votre rapport de durabilité.",
  "partners.trustTitle": "Approuvé par les leaders du secteur",
  "partners.trustSubtitle": "Des entreprises à travers l'Europe font confiance à Surplify",
  "partners.trustUsers": "50+ entreprises",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Économies moyennes",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Annonces vérifiées",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Entreprises partenaires",
  "partners.ctaFinalTitle": "Prêt à économiser?",
  "partners.ctaFinalDesc": "Rejoignez des centaines d'entreprises qui utilisent déjà Surplify.",
  "partners.ctaFinalRegister": "Commencer gratuitement",
  "partners.noCredit": "Sans carte de crédit. Inscription gratuite.",
  "demo.badge": "Réserver une démo",
  "demo.ctaHero": "Réserver une démo",
  "demo.title": "Découvrez Surplify en action",
  "demo.subtitle": "Réservez une démo gratuite et personnalisée avec notre équipe.",
  "demo.point1": "Visite guidée de la plateforme",
  "demo.point2": "Adaptée à votre secteur et vos besoins",
  "demo.point3": "Sans engagement — entièrement gratuit",
  "demo.name": "Nom",
  "demo.namePlaceholder": "Votre nom complet",
  "demo.email": "E-mail professionnel",
  "demo.emailPlaceholder": "nom@entreprise.fr",
  "demo.company": "Entreprise",
  "demo.companyPlaceholder": "Nom de votre entreprise",
  "demo.phone": "Téléphone (facultatif)",
  "demo.phonePlaceholder": "+33 ...",
  "demo.message": "Message (facultatif)",
  "demo.messagePlaceholder": "Décrivez vos besoins...",
  "demo.submit": "Demander une démo",
  "demo.sending": "Envoi en cours...",
  "demo.privacy": "Nous respectons votre vie privée. Vos données ne seront utilisées que pour vous contacter au sujet de votre demande.",
  "demo.requiredFields": "Veuillez remplir tous les champs obligatoires.",
  "demo.successToast": "Demande de démo envoyée avec succès !",
  "demo.errorToast": "Échec de l'envoi. Veuillez réessayer.",
  "demo.successTitle": "Merci !",
  "demo.successDesc": "Votre demande a été reçue. Notre équipe vous contactera dans les 24 heures.",
  "onboarding.step": "Étape",
  "onboarding.of": "sur",
  "onboarding.skip": "Ignorer pour l'instant",
  "onboarding.next": "Suivant",
  "onboarding.finish": "Commencer",
  "onboarding.restartTour": "Relancer la visite",
  "onboarding.step1Title": "Bienvenue sur Surplify",
  "onboarding.step1Desc": "Surplify est la place de marché leader des surplus d'emballages.",
  "onboarding.step1Points": ["Des milliers de matériaux vérifiés", "Économisez jusqu'à 40%", "Suivi ESG automatique"],
  "onboarding.step2Title": "Votre profil d'entreprise",
  "onboarding.step2Desc": "Votre profil représente votre entreprise sur la plateforme.",
  "onboarding.step2Points": ["Ajoutez logo et description", "Vérifiez vos coordonnées", "Définissez vos préférences"],
  "onboarding.step3Title": "Trouver des matériaux",
  "onboarding.step3Desc": "Utilisez la recherche avancée pour trouver exactement ce dont vous avez besoin.",
  "onboarding.step3Points": ["Recherche par fabricant ou numéro d'article", "Filtres par catégorie et pays", "Sauvegardez dans votre liste de suivi"],
  "onboarding.step4Title": "Demander des matériaux",
  "onboarding.step4Desc": "Envoyez une demande directement au fournisseur.",
  "onboarding.step4Points": ["Indiquez la quantité requise", "Ajoutez un message", "Suivez le statut en temps réel"],
  "admin.addCompany": "Ajouter entreprise",
  "admin.addGroup": "Ajouter groupe",
  "admin.addSite": "Ajouter site",
  "admin.approvalRequired": "Approbation requise",
  "admin.approvalRequiredDesc": "Exiger l'approbation du responsable pour les demandes",
  "admin.approve": "Approuver",
  "admin.approveCompany": "Approuver",
  "admin.auditAction": "Action",
  "admin.auditAll": "Tous",
  "admin.auditChanges": "Modifications",
  "admin.auditEntity": "Entite",
  "admin.auditFilterAction": "Filtrer par action",
  "admin.auditFilterEntity": "Filtrer par entite",
  "admin.auditLog": "Journal d'audit",
  "admin.auditLogDesc": "Historique complet de toutes les modifications systeme",
  "admin.auditNextPage": "Suivant",
  "admin.auditNoEntries": "Aucune entree d'audit trouvee.",
  "admin.auditPage": "Page {{page}} de {{pages}}",
  "admin.auditPrevPage": "Precedent",
  "admin.auditTimestamp": "Horodatage",
  "admin.auditUser": "Utilisateur",
  "admin.autoApproval": "Approbation automatique",
  "admin.categories": "Categories",
  "admin.city": "Ville",
  "admin.companyApproved": "Entreprise approuvee",
  "admin.companyCreated": "Entreprise creee avec succes",
  "admin.companyFailed": "Echec de la mise a jour de l'entreprise",
  "admin.companyName": "Nom de l'entreprise",
  "admin.companyNamePlaceholder": "ex. PackPro GmbH",
  "admin.companyRejected": "Entreprise rejetee",
  "admin.contactEmail": "E-mail de contact",
  "admin.contactName": "Nom du contact",
  "admin.contactPhone": "Telephone de contact",
  "admin.country": "Pays",
  "admin.defaultImage": "Image par defaut",
  "admin.docsBlocked": "Docs bloques",
  "admin.domainsAllowed": "Domaines autorises",
  "admin.emailsFailed": "E-mails echoues",
  "admin.emailsSent": "E-mails envoyes",
  "admin.emailsSkipped": "Ignores",
  "admin.escalatedRequests": "Demandes escaladees",
  "admin.escalationDays": "Jours d'escalade",
  "admin.escalationDaysDesc": "Jours avant les notifications d'escalade",
  "admin.externalBlocked": "Externe bloque",
  "admin.externalCompanies": "Entreprises externes",
  "admin.externalCompaniesDesc": "Gerer les inscriptions et approbations des entreprises externes",
  "admin.externalEnabled": "Publication externe activee",
  "admin.externalEnabledDesc": "Autoriser les materiaux a etre visibles en externe",
  "admin.externalOpen": "Externe ouvert",
  "admin.groupAdmin": "Admin de groupe",
  "admin.groupAdminDesc": "Gerer la strategie et les utilisateurs de votre groupe",
  "admin.groupName": "Nom du groupe",
  "admin.groupNamePlaceholder": "ex. Acme Packaging Group",
  "admin.groupUsersDesc": "Gerer et approuver les utilisateurs de votre groupe",
  "admin.guide": "Guide",
  "admin.guideAudit": "Journal d'audit",
  "admin.guideAuditText": "Le journal d'audit fournit un historique complet de toutes les modifications du systeme pour la conformite et la tracabilite. Chaque action est enregistree avec l'utilisateur, l'horodatage, le type d'entite et les donnees de modification detaillees.",
  "admin.guideAuditTip": "Le journal d'audit est immuable et ne peut etre ni modifie ni supprime. Utilisez-le pour les audits de conformite.",
  "admin.guideCategories": "Gestion des categories",
  "admin.guideCategoriesText": "Les categories organisent les materiaux dans une structure arborescente hierarchique. Elles alimentent la navigation laterale du marche et aident les utilisateurs a parcourir les materiaux par type.",
  "admin.guideCategoriesTip": "Les categories supprimees sont desactivees (suppression douce). Les materiaux precedemment assignes restent accessibles.",
  "admin.guideDashboard": "Tableau de bord et rapports",
  "admin.guideDashboardText": "Le tableau de bord fournit des KPIs en temps reel sur l'age de l'inventaire, l'activite des transferts, les metriques de durabilite et la valeur a risque.",
  "admin.guideDashboardTip": "Le rapport de durabilite inclut les economies de CO2 estimees basees sur les quantites de materiaux redistribues.",
  "admin.guideDesc": "Guide complet pour la configuration de la plateforme, la gouvernance et la gestion quotidienne",
  "admin.guideExternal": "Entreprises externes",
  "admin.guideExternalText": "Les entreprises externes peuvent s'inscrire sur la plateforme. Les administrateurs examinent les demandes et les approuvent ou rejettent. Lors de l'approbation, un groupe et un site sont automatiquement crees.",
  "admin.guideExternalTip": "Lors de l'approbation ou du rejet, une notification par e-mail est automatiquement envoyee au contact de l'entreprise.",
  "admin.guideGettingStarted": "Pour commencer",
  "admin.guideGettingStartedText": "Bienvenue sur Surplify! Cette plateforme aide votre organisation a reduire le fonds de roulement en redistribuant les matieres premieres a rotation lente entre les sites.",
  "admin.guideGettingStartedTip": "Utilisez le bouton 'Charger les donnees d'exemple' pour remplir les categories et materiaux de demonstration.",
  "admin.guideImport": "Import/Export Excel",
  "admin.guideImportText": "La page d'importation prend en charge la gestion en masse des materiaux par telechargement de fichiers Excel.",
  "admin.guideImportTip": "Utilisez le mode 'Enrichir uniquement' pour des mises a jour incrementales sans ecraser les donnees existantes.",
  "admin.guideNotifications": "Notifications par e-mail",
  "admin.guideNotificationsText": "La plateforme envoie des notifications automatiques par e-mail pour les demandes escaladees, les nouvelles demandes de materiaux et les changements de statut des entreprises externes.",
  "admin.guideNotificationsTip": "Les e-mails d'escalade sont declenches lorsque les demandes en attente depassent le seuil 'Jours d'escalade' configure.",
  "admin.guideScenarios": "Configuration des scenarios",
  "admin.guideScenariosText": "Les scenarios controlent les regles de gouvernance pour la redistribution des materiaux. Chaque mode ajuste les fenetres de visibilite, les seuils d'escalade, l'acces externe et les exigences d'approbation.",
  "admin.guideScenariosTip": "Le tableau de bord d'impact du scenario montre les effets en temps reel de vos parametres actuels.",
  "admin.guideTitle": "Guide d'administration",
  "admin.guideVotes.title": "Sections du guide les moins bien notees",
  "admin.guideVotes.desc": "Les 5 sections avec les retours utilisateurs les plus negatifs - a revoir en priorite.",
  "admin.guideVotes.empty": "Aucun vote pour le moment.",
  "admin.guideVotes.loading": "Chargement des votes…",
  "admin.guideVotes.unknownSection": "Section inconnue",
  "admin.guideVotes.score": "Score net (pouces leves − baisses)",
  "admin.guideUsers": "Gestion des utilisateurs",
  "admin.guideUsersText": "Les utilisateurs s'inscrivent via la plateforme et doivent etre approuves avant d'acceder aux donnees sensibles. Les administrateurs peuvent gerer les approbations et revoquer l'acces.",
  "admin.guideUsersTip": "Revoquer un utilisateur ne supprime pas son compte. Il peut etre re-approuve a tout moment.",
  "admin.houseNumber": "Numero",
  "admin.industry": "Secteur",
  "admin.internalWindow": "Fenetre interne (jours)",
  "admin.internalWindowDesc": "Jours pendant lesquels les articles sont visibles uniquement en interne",
  "admin.internalWindowItems": "Dans la fenetre interne",
  "admin.lastCheck": "Derniere verification",
  "admin.legalPageContent": "Contenu de la page (HTML)",
  "admin.legalPageTitle": "Titre de la page",
  "admin.legalPages": "Pages legales",
  "admin.legalPagesDesc": "Modifier les pages de support, conditions, mentions legales, confidentialite",
  "admin.legalPreview": "Apercu",
  "admin.loadSettings": "Charger les parametres",
  "admin.manualApproval": "Approbation manuelle",
  "admin.masterData": "Donnees de reference",
  "admin.materialApprovals": "Approbations de materiaux",
  "admin.materialApprovalsDesc": "Examiner et approuver les listages de materiaux externes",
  "admin.mode.aggressive_cash": "Agressif (Cash)",
  "admin.mode.aggressive_cashDesc": "Fenetres plus courtes, liquidation plus rapide",
  "admin.mode.balanced": "Equilibre",
  "admin.mode.balancedDesc": "Regles de gouvernance standard",
  "admin.mode.conservative": "Conservateur",
  "admin.mode.conservativeDesc": "Fenetres plus longues, plus d'approbations",
  "admin.mode.crisis_mode": "Mode crise",
  "admin.mode.crisis_modeDesc": "Mode d'elimination d'urgence",
  "admin.ndaNotSigned": "NDA en attente",
  "admin.ndaSigned": "NDA signe",
  "admin.noCompanies": "Aucune entreprise externe enregistree.",
  "admin.noGroups": "Aucun groupe trouve. Ajoutez votre premier groupe.",
  "admin.noNotifications": "Aucune notification envoyee",
  "admin.noPendingMaterials": "Aucune approbation de materiau en attente",
  "admin.noSites": "Aucun site trouve. Ajoutez votre premiere localisation.",
  "admin.noSitesNoGroup": "Creez d'abord un groupe avant d'ajouter des sites.",
  "admin.notifDaysPending": "Jours en attente",
  "admin.notifExtApproved": "Approuve",
  "admin.notifExtCompany": "Entreprise externe",
  "admin.notifExtRejected": "Rejete",
  "admin.notifMaterial": "Materiau",
  "admin.notifOwner": "Proprietaire",
  "admin.notifRecipients": "Destinataires",
  "admin.notifRequestedQty": "Quantite demandee",
  "admin.notifRequester": "Demandeur",
  "admin.notifSentAt": "Envoye le",
  "admin.notifSite": "Site",
  "admin.notifStatus": "Statut",
  "admin.notifTypeEscalation": "Escalade",
  "admin.notifTypeExtCompany": "Ent. externes",
  "admin.notifTypeNewRequest": "Nouvelle demande",
  "admin.notifications": "Notifications",
  "admin.notificationsDesc": "Historique des e-mails d'escalade et gestion",
  "admin.notificationsTitle": "Notifications par e-mail",
  "admin.orgDesc": "Gerer les organisations locataires",
  "admin.orgTitle": "Groupes d'entreprises",
  "admin.organizations": "Organisations",
  "admin.platformAdminDesc": "Administration de la plateforme - gerer tous les groupes, sites et utilisateurs",
  "admin.postalCode": "Code postal",
  "admin.reject": "Rejeter",
  "admin.rejectCompany": "Rejeter",
  "admin.saveSettings": "Enregistrer les parametres",
  "admin.scenarioImpact": "Impact du scenario",
  "admin.scenarioImpactDesc": "Impact en temps reel des parametres actuels",
  "admin.scenarioMode": "Mode de scenario",
  "admin.scenarios": "Scenarios",
  "admin.scenariosDesc": "Configurer les regles de gouvernance et les flux d'approbation",
  "admin.scenariosTitle": "Configuration des scenarios",
  "admin.seedData": "Charger des donnees d'exemple",
  "admin.selectGroup": "Selectionner le groupe",
  "admin.selectGroupPlaceholder": "Choisir un groupe...",
  "admin.settingsFailed": "Echec de l'enregistrement des parametres",
  "admin.settingsSaved": "Parametres enregistres avec succes",
  "admin.sites": "Sites",
  "admin.sitesDesc": "Gerer les emplacements d'entrepot",
  "admin.sitesTitle": "Sites",
  "admin.street": "Rue",
  "admin.strictDocs": "Documentation stricte",
  "admin.strictDocsActive": "Documentation stricte active",
  "admin.strictDocsDesc": "Bloquer les importations sans fiches techniques",
  "admin.submittedBy": "Soumis par",
  "admin.title": "Administration",
  "admin.totalNotifications": "Total des notifications",
  "admin.triggerCheck": "Verifier maintenant",
  "admin.triggerCheckDesc": "Verifier manuellement les demandes escaladees et envoyer des notifications",
  "admin.triggerCheckFailed": "Echec de la verification d'escalade",
  "admin.triggerCheckSuccess": "Verification d'escalade terminee",
  "admin.uploadDefaultImage": "Telecharger l'image",
  "admin.vatId": "No de TVA",
  "admin.website": "Site web",
  "auth.companyGroup": "Groupe d'entreprise",
  "auth.selectCompanyGroup": "Selectionnez votre groupe...",
  "auth.selectSite": "Selectionnez votre usine...",
  "auth.site": "Usine / Site",
  "bulk.browse": "Parcourir les fichiers",
  "bulk.col.article_number": "No d'article",
  "bulk.col.manufacturer_name": "Fabricant",
  "bulk.col.manufacturer_part_number": "No de piece",
  "bulk.col.notes_internal": "Notes",
  "bulk.col.number_of_rolls": "Rouleaux",
  "bulk.col.quantity": "Quantite",
  "bulk.col.uom": "Unite",
  "bulk.created": "Crees",
  "bulk.downloadTemplate": "Telecharger le modele",
  "bulk.dropHint": "Glissez et deposez votre fichier Excel/CSV ici",
  "bulk.duplicates": "Existant (Mise a jour)",
  "bulk.enriched": "Enrichis",
  "bulk.errors": "Erreurs",
  "bulk.executeImport": "Importer {{count}} lignes",
  "bulk.importComplete": "Importation terminee!",
  "bulk.importError": "Echec de l'importation",
  "bulk.importMode": "Mode d'importation pour les doublons",
  "bulk.importMore": "Importer plus",
  "bulk.importing": "Importation en cours...",
  "bulk.invalidFile": "Format de fichier invalide. Utilisez .xlsx, .xls ou .csv",
  "bulk.modeEnrich": "Enrichir",
  "bulk.modeEnrichDesc": "Remplir uniquement les champs vides, garder les existants",
  "bulk.modeOverwrite": "Ecraser",
  "bulk.modeOverwriteDesc": "Remplacer tous les champs par les valeurs importees",
  "bulk.moreRows": "lignes supplementaires",
  "bulk.newItems": "Nouveaux articles",
  "bulk.parseError": "Echec de l'analyse du fichier",
  "bulk.rejected": "Rejetes",
  "bulk.rowError": "Ligne {{row}}",
  "bulk.rows": "Lignes",
  "bulk.rowsLoaded": "{{count}} lignes chargees",
  "bulk.subtitle": "Importer plusieurs materiaux a la fois via Excel/CSV",
  "bulk.templateDownloaded": "Modele telecharge",
  "bulk.templateError": "Echec du telechargement du modele",
  "bulk.title": "Telechargement en masse",
  "bulk.updated": "Mis a jour",
  "bulk.valid": "Valide",
  "bulk.validate": "Valider les donnees",
  "bulk.validateError": "Echec de la validation",
  "bulk.validating": "Validation en cours...",
  "bulk.validationErrors": "Erreurs de validation",
  "common.deleting": "Suppression...",
  "create.addDocument": "Ajouter un document PDF",
  "create.techSpec": "Fiche technique",
  "create.techSpecHint": "Au moins une fiche technique (PDF) est requise. Les acheteurs en ont besoin pour évaluer le matériau.",
  "create.techSpecRequired": "Obligatoire",
  "create.addTechSpec": "Téléverser une fiche technique (PDF)",
  "create.techSpecRequiredError": "Veuillez téléverser une fiche technique (PDF) avant d'enregistrer.",
  "create.addPhoto": "Photo",
  "create.documents": "Documents (PDF)",
  "create.erpArticleNumber": "No d'article ERP",
  "create.materialIndex": "Index materiau",
  "create.photos": "Photos",
  "dashboard.agingAutoCalculated": "Le vieillissement est calcule automatiquement a partir de la date de production",
  "dashboard.categoryBreakdown": "Repartition par categorie",
  "dashboard.categoryBreakdownDesc": "Principales categories par valeur a risque",
  "dashboard.items": "Articles",
  "dashboard.kEUR": "kEUR",
  "dashboard.skus": "SKUs",
  "dashboard.topRisk": "Materiaux a plus haut risque",
  "dashboard.topRiskDesc": "Materiaux de plus haute valeur (rotation lente/nulle)",
  "dashboard.totalValue": "Valeur totale de l'inventaire",
  "dashboard.totalValueDesc": "Valeur comptable totale de tous les SKUs actifs",
  "dashboard.valueAtRisk": "Valeur a risque",
  "dashboard.valueAtRiskDesc": "Valeur comptable du stock a rotation lente/nulle",
  "ext.alreadyRegistered": "Deja inscrit?",
  "ext.backStep": "Retour",
  "ext.chooseRegistrationType": "Comment souhaitez-vous vous inscrire?",
  "ext.companyInfo": "Informations de l'entreprise",
  "ext.confirmPassword": "Confirmer le mot de passe",
  "ext.continue": "Continuer",
  "ext.createFirstListing": "Lister le premier materiau",
  "ext.createListing": "Lister un materiau",
  "ext.deleteConfirmDesc": "Etes-vous sur de vouloir supprimer ce materiau? Cette action est irreversible.",
  "ext.deleteConfirmTitle": "Supprimer le materiau?",
  "ext.fillRequired": "Veuillez remplir tous les champs obligatoires",
  "ext.groupName": "Nom du groupe",
  "ext.internalUser": "Utilisateur interne?",
  "ext.linkedUsers": "Utilisateurs lies",
  "ext.materialDeleted": "Materiau supprime",
  "ext.myCompany": "Mon entreprise",
  "ext.myListings": "Mes offres",
  "ext.nextStep": "Suivant: Compte utilisateur",
  "ext.noCompanyLinked": "Aucune entreprise externe liee a votre compte",
  "ext.noLinkedUsers": "Aucun utilisateur lie",
  "ext.noListings": "Aucun materiau liste",
  "ext.noListingsDesc": "Listez votre premier materiau pour l'offrir sur le marche.",
  "ext.passwordMismatch": "Les mots de passe ne correspondent pas",
  "ext.passwordTooShort": "Le mot de passe doit comporter au moins 6 caracteres",
  "ext.pendingMessage": "Votre inscription est en cours d'examen. Une fois approuvee, vous pourrez offrir des materiaux sur le marche.",
  "ext.pendingTitle": "Approbation en attente",
  "ext.portalTitle": "Portail entreprise",
  "ext.registerAsExternal": "S'inscrire en tant qu'entreprise externe",
  "ext.registerAsGroup": "En tant que groupe",
  "ext.registerAsGroupDesc": "Entreprise avec plusieurs sites/emplacements",
  "ext.registerAsSite": "En tant que site individuel",
  "ext.registerAsSiteDesc": "Emplacement unique sans groupe parent",
  "ext.registerDesc": "Inscrivez votre entreprise pour offrir des materiaux sur le marche.",
  "ext.registerGroupDesc": "Inscrivez votre groupe pour participer au marche avec plusieurs sites.",
  "ext.registerInternal": "S'inscrire ici",
  "ext.registerSiteDesc": "Inscrivez votre site en tant qu'emplacement unique sur le marche.",
  "ext.registerTitle": "S'inscrire en tant qu'entreprise externe",
  "ext.registrationPending": "Votre entreprise est en cours d'examen. Vous serez notifie lorsque votre acces sera active.",
  "ext.registrationSuccess": "Inscription reussie!",
  "ext.registrationType": "Type",
  "ext.rejectedMessage": "Malheureusement, votre inscription a ete rejetee. Contactez le support pour plus d'informations.",
  "ext.rejectedTitle": "Inscription rejetee",
  "ext.siteName": "Nom du site",
  "ext.submitRegistration": "Soumettre l'inscription",
  "ext.userAccount": "Compte utilisateur",
  "filter.advancedFilters": "Filtres avances",
  "filter.ageBucket": "Anciennete du stock",
  "filter.age_0_90": "< 3 mois",
  "filter.age_181_360": "6-12 mois",
  "filter.age_91_180": "3-6 mois",
  "filter.age_gt_360": "> 12 mois",
  "filter.basicFilters": "Filtres",
  "filter.both": "Les deux",
  "filter.certifications": "Certifications",
  "filter.clearAll": "Tout effacer",
  "filter.clearAllFilters": "Effacer tous les filtres",
  "filter.clearFilters": "Effacer les filtres",
  "filter.complianceFlag": "Indicateur de conformite",
  "filter.compliant": "Conforme",
  "filter.core": "Noyau",
  "filter.coreDiameter": "Diametre du noyau",
  "filter.customerSpecific": "Specifique au client",
  "filter.filters": "Filtres",
  "filter.materialProperties": "Proprietes du materiau",
  "filter.max": "Max",
  "filter.min": "Min",
  "filter.minQuantity": "Quantite minimale",
  "filter.no": "Non",
  "filter.qty": "Qte",
  "filter.quantity": "Quantite",
  "filter.stockDetails": "Details du stock",
  "filter.technicalSpecs": "Specifications techniques",
  "filter.thickness": "Epaisseur",
  "filter.thicknessRange": "Plage d'epaisseur",
  "filter.widthRange": "Plage de largeur",
  "filter.yes": "Oui",
  "group.allSites": "Tous les sites",
  "group.filterSite": "Filtrer par site",
  "group.filterStatus": "Filtrer par statut",
  "group.noMaterials": "Aucun materiau trouve dans votre groupe",
  "group.otherSite": "Autre site",
  "group.ownMaterial": "Materiau propre",
  "group.sites": "Sites",
  "group.skuCount": "{{count}} SKUs",
  "group.subtitle": "Tous les materiaux sur tous les sites de votre groupe",
  "group.title": "Materiaux de mon groupe",
  "group.totalValue": "Valeur totale",
  "masterData.applied": "Donnees de reference appliquees",
  "masterData.appliedLabel": "Donnees de reference appliquees",
  "masterData.matchesFound": "Donnees de reference trouvees",
  "masterData.searchPlaceholder": "Rechercher par fournisseur, no d'article...",
  "myMaterials.allStatuses": "Tous les statuts",
  "myMaterials.archive": "Archiver",
  "myMaterials.archiveDesc": "Le materiau sera archive et ne sera plus visible sur le marche.",
  "myMaterials.archiveTitle": "Archiver le materiau?",
  "myMaterials.archived": "Materiau archive",
  "myMaterials.articles": "articles",
  "myMaterials.bulkUpload": "Telechargement en masse",
  "myMaterials.deleteDesc": "Le materiau et tout l'inventaire associe seront supprimes definitivement.",
  "myMaterials.deleteTitle": "Supprimer le materiau?",
  "myMaterials.deleted": "Materiau supprime",
  "myMaterials.empty": "Aucun article trouve",
  "myMaterials.emptyDesc": "Aucun article n'a encore ete publie sur votre site.",
  "myMaterials.newArticle": "Nouvel article",
  "myMaterials.noSite": "Votre compte n'a pas de site assigne.",
  "myMaterials.noSiteDesc": "Contactez un administrateur pour etre assigne a un site.",
  "myMaterials.noSiteTitle": "Aucun site assigne",
  "myMaterials.quantity": "Qte",
  "myMaterials.searchPlaceholder": "Rechercher des articles...",
  "myMaterials.statusArchived": "Archive",
  "myMaterials.title": "Mes materiaux du site",
  "myMaterials.value": "Valeur",
  "myMaterials.you": "Vous",
  "nav.myGroup": "Mon groupe",
  "nav.myMaterials": "Mes articles",
  "nav.scenario": "Scenario",
  "pagination.next": "Suivant",
  "pagination.previous": "Precedent",
  "preset.applied": "Preselection \"{name}\" appliquee",
  "preset.applyFailed": "Echec de l'application de la preselection",
  "preset.delete": "Supprimer",
  "preset.deleteConfirm": "Supprimer la preselection?",
  "preset.deleteDescription": "La preselection \"{name}\" sera supprimee definitivement.",
  "preset.deleteFailed": "Echec de la suppression de la preselection",
  "preset.deleted": "Preselection supprimee",
  "preset.filters": "filtres",
  "preset.filtersWillBeSaved": "filtres seront enregistres",
  "preset.maxReached": "Maximum atteint",
  "preset.name": "Nom de la preselection",
  "preset.namePlaceholder": "ex. Films FSC > 100mm",
  "preset.nameRequired": "Veuillez entrer un nom de preselection",
  "preset.newName": "Nouveau nom",
  "preset.noFiltersToSave": "Aucun filtre actif a enregistrer",
  "preset.noPresets": "Aucune preselection enregistree",
  "preset.presets": "Preselections",
  "preset.rename": "Renommer",
  "preset.renameFailed": "Echec du renommage de la preselection",
  "preset.renamePreset": "Renommer la preselection",
  "preset.renamed": "Preselection renommee",
  "preset.saveCurrentFilters": "Enregistrer les filtres actuels",
  "preset.saveDescription": "Nommez votre combinaison de filtres pour l'appliquer rapidement plus tard.",
  "preset.saveFailed": "Echec de l'enregistrement de la preselection",
  "preset.saveHint": "Appliquez des filtres et enregistrez-les",
  "preset.savePreset": "Enregistrer le preselection de filtre",
  "preset.saved": "Preselection enregistree",
  "preset.used": "preselections utilisees",
  "scenario.applyChanges": "Appliquer les modifications",
  "scenario.autoApproved": "Auto-approuve",
  "scenario.blocked": "Bloque",
  "scenario.currentSettings": "Parametres actuels",
  "scenario.docsBlocked": "Docs bloques",
  "scenario.enabled": "Active",
  "scenario.escalatedRequests": "Demandes escaladees",
  "scenario.externalAccess": "Acces externe",
  "scenario.internalWindow": "Dans la fenetre interne",
  "scenario.itemsAtRisk": "Articles a risque",
  "scenario.noChanges": "Ajustez les parametres et cliquez sur 'Apercu' pour voir l'effet",
  "scenario.pendingRequests": "Demandes en attente",
  "scenario.preview": "Apercu de l'impact",
  "scenario.previewResult": "Impact projete",
  "scenario.subtitle": "Apercu de l'impact des changements de gouvernance avant application",
  "scenario.title": "Analyse What-If des scenarios",
  "scenario.valueAtRisk": "Valeur a risque",
  "scenario.whatIf": "Apercu What-If",
  "search.allMaterials": "Tous les materiaux",
  "search.filtering": "Filtrage en cours...",
  "search.materialsFound": "materiaux trouves",
  "search.resultsFor": "Resultats pour",
  "search.tryAdjusting": "Essayez d'ajuster vos filtres ou termes de recherche",
  "sort.newestFirst": "Plus récents d'abord",
  "sort.oldestFirst": "Plus anciens d'abord",
  "sort.priceHighLow": "Prix: Decroissant",
  "sort.priceLowHigh": "Prix: Croissant",
  "sort.quantityHighLow": "Quantite: Decroissant",
  "sort.sortBy": "Trier par",
  "status.archived": "Archive",
  "status.pendingApproval": "Approbation en attente",
  "admin.guideAuditSteps": ["Naviguez vers Admin > Journal d'audit.", "Utilisez le filtre de type d'entite.", "Utilisez le filtre d'action.", "Developpez les 'Modifications' pour voir les donnees modifiees.", "Utilisez la pagination pour naviguer dans l'historique."],
  "admin.guideCategoriesSteps": ["Naviguez vers Admin > Categories pour voir l'arborescence.", "Cliquez sur 'Ajouter une categorie' pour une categorie principale.", "Cliquez sur '+' sur une categorie pour ajouter une sous-categorie.", "Modifiez ou supprimez les categories existantes.", "Les categories peuvent etre reordonnees via le champ d'ordre."],
  "admin.guideDashboardSteps": ["Naviguez vers le Tableau de bord.", "Consultez les KPIs globaux.", "Utilisez le filtre de site pour des metriques specifiques.", "Telechargez les rapports PDF de durabilite.", "Surveillez les materiaux a risque."],
  "admin.guideExternalSteps": ["Les entreprises externes s'inscrivent via le formulaire public (/register-external).", "Naviguez vers Admin > Entreprises externes pour examiner les demandes.", "Cliquez sur 'Approuver' pour activer l'entreprise.", "Cliquez sur 'Rejeter' pour refuser l'acces.", "Les entreprises approuvees peuvent lister leurs materiaux.", "Cliquez sur une ligne d'entreprise pour voir les utilisateurs lies."],
  "admin.guideGettingStartedSteps": ["Creez votre groupe d'entreprise et au moins un site sous Admin > Organisations et Sites.", "Chargez les donnees initiales avec le bouton 'Charger les donnees' (une seule fois pour la demo/test).", "Invitez les utilisateurs en partageant le lien d'inscription. Approuvez les nouveaux sous Admin > Utilisateurs.", "Configurez votre mode de gouvernance prefere sous Admin > Scenarios.", "Telechargez des materiaux via la page d'importation ou creez-les individuellement."],
  "admin.guideImportSteps": ["Naviguez vers la page d'importation.", "Telechargez le modele Excel.", "Remplissez vos donnees et telechargez le fichier.", "Verifiez les resultats de validation.", "Choisissez un mode d'importation.", "Executez l'importation."],
  "admin.guideNotificationsSteps": ["Naviguez vers Admin > Notifications.", "Consultez les statistiques: total envoye, echoue et par type.", "Cliquez sur 'Verifier maintenant' pour executer la verification d'escalade.", "Parcourez l'historique des notifications.", "Les notifications necessitent une cle API Resend configuree."],
  "admin.guideScenariosSteps": ["Selectionnez un mode: Equilibre (par defaut), Conservateur, Agressif (Cash) ou Mode Crise.", "Ajustez la 'Fenetre interne' (jours ou les materiaux restent uniquement internes).", "Definissez les 'Jours d'escalade' pour les notifications automatiques.", "Activez/desactivez 'Externe active' pour controler l'acces externe.", "Activez/desactivez 'Approbation requise' pour l'approbation automatique ou manuelle.", "Activez 'Documentation stricte' pour bloquer les articles sans fiches techniques."],
  "admin.guideUsersSteps": ["Naviguez vers Admin > Utilisateurs pour voir tous les inscrits.", "Les utilisateurs en attente sont marques d'un indicateur jaune.", "Cliquez sur 'Approuver' pour accorder l'acces complet au marche.", "Cliquez sur 'Revoquer' pour desactiver temporairement l'acces.", "Les administrateurs sont automatiquement approuves a l'inscription."],
  "admin.pendingRequests": "Demandes en attente",
  "app.subtitle": "rendre le surplus utile",
  "auth.loginError": "E-mail ou mot de passe invalide",
  "auth.loginSuccess": "Connexion reussie!",
  "auth.passwordTooShort": "Le mot de passe doit comporter au moins 6 caracteres",
  "auth.passwordsNoMatch": "Les mots de passe ne correspondent pas",
  "auth.registerError": "L'inscription a echoue",
  "filter.allCategories": "Toutes les catégories",
  "home.loginRequired": "Connectez-vous pour utiliser la liste de suivi",
  "home.materialsCount": "materiaux",
  "home.noMaterials": "Aucun materiau trouve.",
  "home.seedDescription": "Vous pouvez charger des donnees d'exemple pour commencer.",
  "home.seedError": "Erreur lors du chargement des donnees",
  "home.seedSuccess": "Donnees chargees avec succes! Actualisation...",
  "home.seeding": "Chargement...",
  "home.watchlistError": "Erreur lors de la mise a jour de la liste de suivi",
  "sort.dateAdded": "Date d'ajout",
  "sort.price": "Prix",
  "sort.quantity": "Quantite",
  "admin.platformSettings": "Paramètres",
  "admin.resendEmail": "Renvoyer l'e-mail",
  "guide.title": "Aide & FAQ",
  "guide.subtitle": "Manuel utilisateur et réponses aux questions fréquentes",
  "guide.searchPlaceholder": "Rechercher dans le manuel et la FAQ...",
  "guide.tabGuide": "Manuel utilisateur",
  "guide.tabFaq": "FAQ",
  "guide.noResults": "Aucun résultat pour",
  "guide.topic": "sujet",
  "guide.topics": "sujets",
  "home.hero.badge": "B2B circulaire · Impression & Emballage",
  "home.hero.verified": "Vérifié UE",
  "home.hero.headlineA": "Réutiliser.",
  "home.hero.headlineB": "Réparer.",
  "home.hero.headlineC": "Redistribuer.",
  "home.hero.subtitle": "Surplify est la place de marché B2B circulaire pour l'industrie de l'impression et de l'emballage — donnant une seconde vie aux matériaux excédentaires, pièces détachées et machines d'occasion. Chaque transaction évite la production neuve, économise du CO₂ et préserve le fonds de roulement.",
  "home.hero.impactPrefix": "Économisé ensemble jusqu'ici :",
  "home.hero.impactSuffix": "de CO₂",
  "home.hero.searchPlaceholder": "Fabricant, n° de pièce, matériau, modèle…",
  "home.hero.searchBtn": "Rechercher",
  "home.hero.verticalMaterials": "Excédent",
  "home.hero.verticalSpareParts": "Pièces détachées",
  "home.hero.verticalMachines": "Machines",
  "home.hero.verticalPaints": "Encres & revêtements",
  "home.hero.ctaPostWanted": "Publier une demande d'achat",
  "home.hero.ctaForSellers": "Pour les vendeurs",
  "home.hero.ctaGuide": "Aide & guide",
  "home.hero.trustVies": "TVA vérifiée par EU VIES",
  "home.hero.trustCompanies": "Comptes d'entreprise vérifiés",
  "home.hero.trustCircular": "Économie circulaire",
  "home.newco.badge": "Nouveau sur Surplify ?",
  "home.newco.title": "Votre entreprise sur la place de marché B2B en 3 étapes",
  "home.newco.subtitle": "Matières excédentaires, résidus, peintures, pièces détachées et machines d'impression d'occasion — tout sur une seule plateforme. Démarrez gratuitement, échangez équitablement, documentez en conformité REACH/CLP.",
  "home.newco.step1Title": "Créez votre entreprise",
  "home.newco.step1Desc": "Nom de l'entreprise, n° de TVA, adresse — validé par VIES",
  "home.newco.step2Title": "Créez votre première annonce",
  "home.newco.step2Desc": "Matière, peinture, pièce détachée ou machine — remplissez le formulaire, c'est fait",
  "home.newco.step3Title": "Recevez des demandes et vendez",
  "home.newco.step3Desc": "Commission uniquement en cas de transaction réussie. Aucuns frais d'installation.",
  "home.newco.ctaRegister": "Enregistrez votre entreprise maintenant",
  "home.newco.ctaPartners": "Pour partenaires et grands comptes",
  "home.newco.disclaimer": "Forfait de démarrage gratuit · Aucune carte de crédit requise · Conforme RGPD et B2B",
  "home.newco.whatYouGet": "Ce que vous obtenez",
  "home.newco.freeTier": "Avec le forfait de démarrage gratuit",
  "home.newco.feat1Label": "4 verticales de matières",
  "home.newco.feat1Sub": "Matières · Peintures · Pièces détachées · Machines",
  "home.newco.feat2Label": "Annonces illimitées",
  "home.newco.feat2Sub": "Aucune limite de quantité sur le forfait standard",
  "home.newco.feat3Label": "Algorithme de correspondance",
  "home.newco.feat3Sub": "Les demandes des acheteurs sont attribuées automatiquement",
  "home.newco.feat4Label": "Conformité REACH/CLP",
  "home.newco.feat4Sub": "Fiches de données de sécurité et pictogrammes SGH intégrés",
  "home.newco.feat5Label": "Reporting de durabilité",
  "home.newco.feat5Sub": "Les économies de CO₂ sont documentées automatiquement",
  "home.newco.freeBadge": "Démarrez 100% gratuitement",
  "home.pillar.materials.label": "Excédent",
  "home.pillar.materials.title": "Excédents & matériaux",
  "home.pillar.materials.desc": "Films, papier, bobines et semi-finis — maintenus dans le cycle au lieu d'être incinérés.",
  "home.pillar.materials.metric": "annonces actives",
  "home.pillar.spareParts.label": "Pièces détachées",
  "home.pillar.spareParts.title": "Pièces détachées & modules",
  "home.pillar.spareParts.desc": "Pièces OEM réutilisées — chaque composant sauvé évite une nouvelle extraction et production.",
  "home.pillar.spareParts.metric": "nouveaux",
  "home.pillar.machines.label": "Machines",
  "home.pillar.machines.title": "Machines d'impression",
  "home.pillar.machines.desc": "Les presses d'occasion remplacent les neuves — jusqu'à 80 % de CO₂ en moins.",
  "home.pillar.machines.metric": "disponibles",
  "home.pillar.paints.label": "Encres & revêtements",
  "home.pillar.paints.title": "Encres, vernis & additifs",
  "home.pillar.paints.desc": "Encres, vernis et additifs chimiques excédentaires — maintenus en production au lieu d'être traités comme déchets dangereux.",
  "home.pillar.paints.metric": "en stock",
  "home.sustain.liveImpact": "Impact en direct",
  "home.sustain.co2": "CO₂ économisé",
  "home.sustain.redistributed": "redistribué",
  "home.sustain.sites": "sites",
  "home.sustain.circular": "taux circulaire",
  "home.sustain.atRisk": "à risque",
  "home.machines.label": "Vertical · Machines",
  "home.machines.title": "Machines d'impression d'occasion, pour un second cycle de production.",
  "home.machines.subtitle": "Chaque presse d'occasion remplace une presse neuve — avec une fraction du CO₂ et des matières premières. Inspection optionnelle, compatibilité vérifiée.",
  "home.machines.seeAll": "Toutes les machines",
  "home.machines.emptyDesc": "Aucune machine d'impression listée pour le moment.",
  "home.machines.emptyCreate": "Créer une annonce",
  "home.spareParts.label": "Vertical · Pièces détachées",
  "home.spareParts.title": "Pièces détachées OEM — maintenues en circulation.",
  "home.spareParts.subtitle": "Stocks inutilisés, tampons d'obsolescence, lignes démantelées. Nous redirigeons les pièces vers la production plutôt que vers la ferraille.",
  "home.spareParts.seeAll": "Toutes les pièces détachées",
  "home.spareParts.emptyDesc": "Aucune pièce détachée listée pour le moment.",
  "home.spareParts.emptyCreate": "Créer la première annonce",
  "home.paints.label": "Vertical · Encres & revêtements",
  "home.paints.title": "Encres, vernis et additifs excédentaires — de retour dans la presse.",
  "home.paints.subtitle": "Teintes abandonnées, lots restants, stocks retirés. Nous remettons les produits chimiques d'impression en production au lieu de payer des frais d'élimination.",
  "home.paints.seeAll": "Toutes les encres & revêtements",
  "home.paints.emptyDesc": "Aucune encre, vernis ou additif listé pour le moment.",
  "home.paints.emptyCreate": "Créer la première annonce",
  "home.materials.label": "Vertical · Excédent",
  "home.materials.title": "Excédent & surproduction.",
  "home.materials.subtitle": "Stock en direct des séries de production, vidages d'entrepôts et retours qualité — réinjecté directement dans l'industrie.",
  "home.trust.vies.title": "TVA EU VIES",
  "home.trust.vies.desc": "Vérification automatique des numéros de TVA pour chaque entreprise enregistrée.",
  "home.trust.companies.title": "Entreprises vérifiées",
  "home.trust.companies.desc": "Seuls les comptes B2B vérifiés ont un accès complet au marché.",
  "home.trust.csv.title": "Import CSV en masse",
  "home.trust.csv.desc": "Listez des milliers de pièces et matériaux en un seul import.",
  "home.trust.circular.title": "Économie circulaire",
  "home.trust.circular.desc": "Chaque redistribution évite une production neuve et réduit les émissions du scope 3.",
  "machine.card.label": "Machine d'impression",
  "machine.card.year": "Année",
  "machine.card.hours": "h",
  "machine.card.width": "Largeur",
  "machine.card.price": "Prix",
  "sparePart.card.label": "Pièce détachée",
  "sparePart.card.compatible": "Compatible :",
  "sparePart.card.single": "Article unique"
};

export default fr;
